import LoginForm from "@/features/auth/LoginForm";
import { useAuthentication } from "@/hooks/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const authentication = useAuthentication();
  const nav = useNavigate();

  useEffect(() => {
    if (!authentication) return;

    if (window.history.length <= 2) {
      nav("/", { replace: true });
      return;
    }

    // 일반 경우 → 뒤로가기
    nav(-1);
  }, [authentication, nav]);

  // 권한 존재
  if (authentication) {
    return null;
  }

  return (
    <div className="grid-layout pt-40">
      <LoginForm />
    </div>
  );
}
